import { get } from 'lodash';

export const getErrorMessage = (error, defaultMessage) => {
  const platformErrMessage = get(error, 'errors.msg');
  const errorMessage = get(error, 'msg');

  return platformErrMessage || errorMessage || defaultMessage;
};
